"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createBakedShadow;
var _three = require("three");
var _setLightShadow = _interopRequireDefault(require("./setLightShadow"));
var _canvasBlur = _interopRequireDefault(require("./canvasBlur"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function createBakedShadow(scene, options) {
  if (!scene) {
    return;
  }
  var _options$withMaterial = options.withMaterial,
    withMaterial = _options$withMaterial === void 0 ? false : _options$withMaterial,
    _options$config = options.config,
    config = _options$config === void 0 ? {} : _options$config;
  var _config$lightPosition = config.lightPositionOffset,
    lightPositionOffset = _config$lightPosition === void 0 ? {
      x: 0,
      y: 0,
      z: 0
    } : _config$lightPosition,
    _config$shadowMapSize = config.shadowMapSize,
    shadowMapSize = _config$shadowMapSize === void 0 ? 512 : _config$shadowMapSize,
    _config$groundScaling = config.groundScaling,
    groundScaling = _config$groundScaling === void 0 ? 2 : _config$groundScaling;

  // activate shadows and disable other lights
  scene.traverse(function (object) {
    if (object.isMesh) {
      object.castShadow = true;
      if (object.material) {
        object.material.shadowSide = _three.DoubleSide;
      }
    }
    if (object.isLight) {
      object.visible = false;
    }
  });

  // remember the original values and set them to null (we need a white background)
  var environment = scene.environment,
    background = scene.background;
  scene.environment = null;
  scene.background = null;

  // get bounding parameters for positioning and scaling
  scene.updateWorldMatrix(true, true);
  var box = new _three.Box3().expandByObject(scene);
  var sphere = box.getBoundingSphere(new _three.Sphere());
  var radius = sphere.radius;
  var shadowGeometry = new _three.PlaneGeometry(1, 1);
  shadowGeometry.rotateX(-Math.PI * 0.5);
  shadowGeometry.rotateY(Math.PI);
  var shadowGround = new _three.Mesh(shadowGeometry, new _three.ShadowMaterial({
    color: 0x000000
  }));
  shadowGround.receiveShadow = true;

  // set the ground positions right below the model bounding box
  shadowGround.position.set(sphere.center.x, box.min.y - 0.01, sphere.center.z);
  shadowGround.scale.set(groundScaling * radius * 2, 1, groundScaling * radius * 2);
  scene.add(shadowGround);
  var shadowLight = new _three.DirectionalLight(0xffffff, 1);
  scene.add(shadowLight);
  shadowLight.target = shadowGround;
  var positionOffset = new _three.Vector3(lightPositionOffset.x, lightPositionOffset.y, lightPositionOffset.z);
  shadowLight.position.set(sphere.center.x, sphere.center.y + radius, sphere.center.z).add(positionOffset);
  (0, _setLightShadow["default"])(shadowLight, radius * 2, {
    cameraProps: {
      far: shadowLight.position.length() * 2,
      shadowMapSize: shadowMapSize
    }
  });

  // calculate the canvas size for the rendered shadow
  var canvasSize = shadowMapSize * groundScaling;

  // create and set the new render target
  var renderTarget = new _three.WebGLRenderTarget(canvasSize, canvasSize);
  var renderer = new _three.WebGLRenderer({
    alpha: true,
    antialias: true
  });
  renderer.shadowMap.enabled = true;
  renderer.shadowMap.type = _three.PCFSoftShadowMap;
  renderer.setRenderTarget(renderTarget);

  // create a camera to capture only the shadowGround plane (with the shadow)
  var shadowCamera = shadowLight.shadow.camera.clone();
  scene.add(shadowCamera);
  shadowCamera.position.copy(shadowGround.position);
  shadowCamera.position.y = shadowGround.position.y + 0.01;
  shadowCamera.far = 0.015;
  shadowCamera.updateProjectionMatrix();
  shadowCamera.lookAt(shadowGround.position);
  renderer.render(scene, shadowCamera);
  var shadowCanvas = copyRenderTargetToCanvas(renderer, renderTarget);
  var blurredCanvas = applyShadowEffects(shadowCanvas, config);
  scene.remove(shadowCamera, shadowGround, shadowLight);

  // turn off shadows, activate lights
  scene.traverse(function (object) {
    if (object.isMesh) {
      object.castShadow = false;
    }
    if (object.isLight) {
      object.visible = true;
    }
  });

  // restore original values
  scene.environment = environment;
  scene.background = background;
  renderer.dispose();
  if (withMaterial) {
    var texture = new _three.CanvasTexture(blurredCanvas);
    texture.flipY = false;
    return new _three.MeshStandardMaterial({
      map: texture,
      transparent: true
    });
  }
  return blurredCanvas;
}
function copyRenderTargetToCanvas(renderer, renderTarget, dstCanvas) {
  var width = renderTarget.width,
    height = renderTarget.height;
  var pixelBuffer = new Uint8ClampedArray(4 * width * height);
  renderer.readRenderTargetPixels(renderTarget, 0, 0, width, height, pixelBuffer);
  var imageData = new ImageData(pixelBuffer, width, height);
  var canvas = dstCanvas || document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  var ctx = canvas.getContext("2d");
  ctx.putImageData(imageData, 0, 0);
  return canvas;
}
function applyShadowEffects(canvas, config) {
  var _config$shadowTexture = config.shadowTextureScaling,
    shadowTextureScaling = _config$shadowTexture === void 0 ? 0.96 : _config$shadowTexture,
    _config$blurRadius = config.blurRadius,
    blurRadius = _config$blurRadius === void 0 ? 6 : _config$blurRadius,
    _config$shadowOpacity = config.shadowOpacity,
    shadowOpacity = _config$shadowOpacity === void 0 ? 0.8 : _config$shadowOpacity;
  var width = canvas.width,
    height = canvas.height;
  var blurCanvas = document.createElement("canvas");
  blurCanvas.width = width;
  blurCanvas.height = height;
  var blurCtx = blurCanvas.getContext("2d");
  var shadowTextureOffset = (1 - shadowTextureScaling) * 0.5;
  blurCtx.globalAlpha = shadowOpacity;
  blurCtx.drawImage(canvas, width * shadowTextureOffset, height * shadowTextureOffset, width * shadowTextureScaling, height * shadowTextureScaling);
  (0, _canvasBlur["default"])(blurCtx, blurRadius);
  return blurCanvas;
}